// Items per page functionality
function setProductItemsPerPage(value) {
  if (value) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { products_items_per_page: value } }),
    })
      .then(() => {
        window.location.href =
          window.location.pathname + "?page=1&items=" + value;
      })
      .catch((error) => {
        console.error("Error updating items per page:", error);
      });
  }
}

// Items per page for search results
function setSearchItemsPerPage(value) {
  if (value) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { search_items_per_page: value } }),
    })
      .then(() => {
        const url = new URL(window.location.href);
        url.searchParams.set("page", "1");
        url.searchParams.set("items", value);
        window.location.href = url.pathname + url.search;
      })
      .catch((error) => {
        console.error("Error updating search items per page:", error);
      });
  }
}

function productListingFilter() {
    // Filter modal functionality
  const openFilterBtn = document.getElementById("open-filter");
  const closeFilterBtn = document.getElementById("close-filter");
  const filterModal = document.getElementById("filter-modal");
    
    if (openFilterBtn && filterModal) {
    openFilterBtn.addEventListener("click", () => {
      filterModal.classList.remove("hidden");
      document.body.style.overflow = "hidden"; // Prevent background scrolling
        });
    }
    
    if (closeFilterBtn && filterModal) {
    closeFilterBtn.addEventListener("click", () => {
      filterModal.classList.add("hidden");
      document.body.style.overflow = ""; // Restore scrolling
        });
    }
    
    // Close modal when clicking outside
    if (filterModal) {
    filterModal.addEventListener("click", (e) => {
            if (e.target === filterModal) {
        filterModal.classList.add("hidden");
        document.body.style.overflow = ""; // Restore scrolling
            }
        });
    }

    // View more functionality for filter values
    // const viewMoreButtons = document.querySelectorAll('[data-view-more]');
    // viewMoreButtons.forEach(button => {
    //     button.addEventListener('click', function() {
    //         const filterBlock = this.closest('[data-filter-block]');
    //         const hiddenItems = filterBlock.querySelectorAll('.filter-item.hidden');
    //         const isExpanded = !hiddenItems[0]?.classList.contains('hidden');
            
    //         hiddenItems.forEach(item => {
    //             if (isExpanded) {
    //                 item.classList.add('hidden');
    //             } else {
    //                 item.classList.remove('hidden');
    //             }
    //         });
            
    //         this.textContent = isExpanded ? 'View more' : 'View less';
    //     });
    // });
}

document.addEventListener("DOMContentLoaded", function () {
    productListingFilter();
  const toggleCategories = document.getElementById("toggle-categories");
  const extraCategories = document.getElementById("extra-categories");
  if (toggleCategories)
    toggleCategories.addEventListener("click", () => {
      extraCategories.classList.toggle("hidden");
      toggleCategories.textContent = extraCategories.classList.contains(
        "hidden"
      )
        ? "View More"
        : "View Less";
    });

  const toggleBrands = document.getElementById("toggle-brands");
  const extraBrands = document.getElementById("extra-brands");
  if (toggleBrands)
    toggleBrands.addEventListener("click", () => {
      extraBrands.classList.toggle("hidden");
      toggleBrands.textContent = extraBrands.classList.contains("hidden")
        ? "View More"
        : "View Less";
    });

  const toggleCategoriesMobile = document.getElementById(
    "toggle-categories-mobile"
  );
  const extraCategoriesMobile = document.getElementById(
    "extra-categories-mobile"
  );
  if (toggleCategoriesMobile)
    toggleCategoriesMobile.addEventListener("click", () => {
      extraCategoriesMobile.classList.toggle("hidden");
      toggleCategoriesMobile.textContent =
        extraCategoriesMobile.classList.contains("hidden")
          ? "View More"
          : "View Less";
    });

  const toggleBrandsMobile = document.getElementById("toggle-brands-mobile");
  const extraBrandsMobile = document.getElementById("extra-brands-mobile");
  if (toggleBrandsMobile)
    toggleBrandsMobile.addEventListener("click", () => {
      extraBrandsMobile.classList.toggle("hidden");
      toggleBrandsMobile.textContent = extraBrandsMobile.classList.contains(
        "hidden"
      )
        ? "View More"
        : "View Less";
    });

  const filterCheckboxes = document.querySelectorAll(".filter-checkbox");
  filterCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const url = checkbox.checked
        ? checkbox.dataset.urlAdd
        : checkbox.dataset.urlRemove;
        if (url) {
            window.location.href = url;
        }
        });
    });
});
